import { render, staticRenderFns } from "./MenuNavigator.vue?vue&type=template&id=529d09f8"
import script from "./MenuNavigator.vue?vue&type=script&lang=js"
export * from "./MenuNavigator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports